/* Normalise translated option names without changing Shopify variant IDs or prices. */
(()=>{
 function parse(rows){
  const data={limited:[],unlimited:[]};
  for(const row of rows){
   const title=String(row.title||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'');
   const duration=title.match(/(\d+)\s*(?:days?|jours?|tag(?:e|en)?|dias?|giorn[oi]|dag(?:en)?)\b/i);
   const days=Number(duration?.[1]||0),unlimited=/unlimited|illimit|ilimit|unbegrenzt|onbeperkt/i.test(title);
   const entry={id:row.id,price:row.price/100,cap:row.compare_at_price>row.price?row.compare_at_price/100:0,popular:/popular|populaire|populair|popolare|beliebt/i.test(title),available:row.available!==false};
   // A sold-out variant cannot be added to the cart: hide it instead of failing at checkout.
   if(!entry.available)continue;
   // Ignore retired upgrade options that may remain in the Shopify catalogue.
   if(unlimited&&/(?:[+＋]|\bplus\b)/i.test(title))continue;
   if(unlimited&&days){data.unlimited.push({...entry,days});continue}
   const amount=title.match(/(\d+(?:[.,]\d+)?)\s*(GB|Go|MB|Mo)\b/i);
   if(!amount||!days)continue;
   const count=Number(amount[1].replace(',','.')),mb=/^m/i.test(amount[2]),gb=mb?count/1000:count;
   // En français on écrit Go / Mo, les autres langues gardent GB / MB.
   const fr=/^fr/i.test((typeof document!=='undefined'&&document.documentElement.lang)||'');
   data.limited.push({...entry,label:count+(mb?(fr?' Mo':'MB'):(fr?' Go':'GB')),sub:days+'Days',gb,mb,ppg:gb?(entry.price/gb).toFixed(2):'0'});
  }
  return data;
 }
 if(typeof module==='object'&&module.exports)module.exports={parse};
 if(typeof document==='undefined')return;
 const source=document.getElementById('wr-raw-variants'),target=document.getElementById('nps-variant-data');
 if(source&&target){try{target.textContent=JSON.stringify(parse(JSON.parse(source.textContent)))}catch(error){console.error('Unable to read Shopify variant options',error)}}
})();
